// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"4dc08dd5","230":"d1a2e88a","306":"8bc98c85","331":"dae0dd80","929":"60b41e47"}[chunkId] + ".chunk.js";
};